// extracted by mini-css-extract-plugin
export default {"editor":"ImageEditor_editor__yZDgV","cropper":"ImageEditor_cropper__ZI9xn","save":"ImageEditor_save__FxbA5","close":"ImageEditor_close__g0A0E"};